<template>
    <EDCHeader />
    <div class="account">
        <div class="account__hero">
            <div class="account__hero-bk">
                <img class="account__hero-bk-image" src="https://almacenamientounicesar.blob.core.windows.net/enamoratedelcesar/assets/media/media/business/image_item/Banner_4.jpg" />
                <!-- <div class="account__hero-bk-profile">
                    <img src="https://almacenamientounicesar.blob.core.windows.net/enamoratedelcesar/assets/media/media/business/image_item/Banner_4.jpg" />
                </div> -->
            </div>
            <div class="account__hero-options">
                <div class="account__hero-authenticated" v-show="isAuthenticated">
                    <div class="account__hero-person-info">
                        <p class="account__hero-person-name">{{ user.firstname + " " + user.lastname }}</p>
                        <p class="account__hero-person-email">{{ user.email }}</p>
                    </div>
                    <button class="account__hero-person-edit" @click="openAuthModal('update')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                            <path d="M11.0833 34.575C10.3042 34.575 9.63715 34.2976 9.08229 33.7427C8.52743 33.1879 8.25 32.5208 8.25 31.7417V11.9083C8.25 11.1292 8.52743 10.4622 9.08229 9.9073C9.63715 9.35244 10.3042 9.07501 11.0833 9.07501H23.7271L20.8938 11.9083H11.0833V31.7417H30.9167V21.8958L33.75 19.0625V31.7417C33.75 32.5208 33.4726 33.1879 32.9177 33.7427C32.3628 34.2976 31.6958 34.575 30.9167 34.575H11.0833ZM26.9146 9.88959L28.9333 11.8729L19.5833 21.2229V23.2417H21.5667L30.9521 13.8563L32.9708 15.8396L22.7708 26.075H16.75V20.0542L26.9146 9.88959ZM32.9708 15.8396L26.9146 9.88959L30.4563 6.34792C31.0229 5.78126 31.7017 5.49792 32.4927 5.49792C33.2837 5.49792 33.9507 5.78126 34.4938 6.34792L36.4771 8.36667C37.0201 8.90973 37.2917 9.57084 37.2917 10.35C37.2917 11.1292 37.0201 11.7903 36.4771 12.3333L32.9708 15.8396Z" fill="#503B2F"/>
                        </svg>
                    </button>
                </div>
                <div class="account__hero-not-authenticated" v-show="isAuthenticated === false">
                    <EDCButton label="Regístrate" @click="openAuthModal('register')" />
                    <p class="account__hero-login-text">
                        ¿Tienes una cuenta?
                        <a class="account__hero-login-link" @click="openAuthModal('login')">Iniciar sesión</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="account__options-list">
            <router-link class="account__option-item" :to="{ name: 'news' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M4 21C3.45 21 2.979 20.804 2.587 20.412C2.195 20.02 1.99934 19.5493 2 19V5C2 4.45 2.196 3.979 2.588 3.587C2.98 3.195 3.45067 2.99934 4 3H20C20.55 3 21.021 3.196 21.413 3.588C21.805 3.98 22.0007 4.45067 22 5V19C22 19.55 21.804 20.021 21.412 20.413C21.02 20.805 20.5493 21.0007 20 21H4ZM4 19H20V5H4V19ZM6 17H18V15H6V17ZM6 13H10V7H6V13ZM12 13H18V11H12V13ZM12 9H18V7H12V9Z" fill="#503B2F"/>
                </svg>
                Lo nuevo
            </router-link>
            <router-link class="account__option-item" :to="{ name: 'news' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M7 17C6.45 17 5.979 16.804 5.587 16.412C5.195 16.02 4.99934 15.5493 5 15V5C5 4.45 5.196 3.979 5.588 3.587C5.98 3.195 6.45067 2.99934 7 3H21C21.55 3 22.021 3.196 22.413 3.588C22.805 3.98 23.0007 4.45067 23 5V15C23 15.55 22.804 16.021 22.412 16.413C22.02 16.805 21.5493 17.0007 21 17H7ZM14 12.3L7 7.425V15H21V7.425L14 12.3ZM14 9.85L21 5H7L14 9.85ZM3 21C2.45 21 1.979 20.804 1.587 20.412C1.195 20.02 0.999335 19.5493 1 19V6.5H3V19H19.5V21H3Z" fill="#503B2F"/>
                </svg>
                Contacto
            </router-link>
            <router-link class="account__option-item" :to="{ name: 'contact' }">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 17C12.2833 17 12.521 16.904 12.713 16.712C12.905 16.52 13.0007 16.2827 13 16V12C13 11.7167 12.904 11.479 12.712 11.287C12.52 11.095 12.2827 10.9993 12 11C11.7167 11 11.479 11.096 11.287 11.288C11.095 11.48 10.9993 11.7173 11 12V16C11 16.2833 11.096 16.521 11.288 16.713C11.48 16.905 11.7173 17.0007 12 17ZM12 9C12.2833 9 12.521 8.904 12.713 8.712C12.905 8.52 13.0007 8.28267 13 8C13 7.71667 12.904 7.479 12.712 7.287C12.52 7.095 12.2827 6.99933 12 7C11.7167 7 11.479 7.096 11.287 7.288C11.095 7.48 10.9993 7.71733 11 8C11 8.28333 11.096 8.521 11.288 8.713C11.48 8.905 11.7173 9.00067 12 9ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6867 5.825 19.9743 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26333 14.6833 2.00067 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31333 6.88333 4.02567 5.825 4.925 4.925C5.825 4.025 6.88333 3.31267 8.1 2.788C9.31667 2.26333 10.6167 2.00067 12 2C13.3833 2 14.6833 2.26267 15.9 2.788C17.1167 3.31333 18.175 4.02567 19.075 4.925C19.975 5.825 20.6877 6.88333 21.213 8.1C21.7383 9.31667 22.0007 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6867 17.1167 19.9743 18.175 19.075 19.075C18.175 19.975 17.1167 20.6877 15.9 21.213C14.6833 21.7383 13.3833 22.0007 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#503B2F"/>
                </svg>
                Nosotros
            </router-link>
            <router-link class="account__option-item" :to="{ name: 'terms' }" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M14 8.775C14 8.625 14.0543 8.47067 14.163 8.312C14.2717 8.15333 14.392 8.04933 14.524 8C15.0073 7.83333 15.4907 7.70833 15.974 7.625C16.4573 7.54167 16.966 7.5 17.5 7.5C17.8333 7.5 18.1627 7.521 18.488 7.563C18.8133 7.605 19.134 7.659 19.45 7.725C19.6 7.75833 19.7293 7.84167 19.838 7.975C19.9467 8.10833 20.0007 8.25833 20 8.425C20 8.70833 19.9083 8.91667 19.725 9.05C19.5417 9.18333 19.3083 9.21667 19.025 9.15C18.7917 9.1 18.546 9.06233 18.288 9.037C18.03 9.01167 17.7673 8.99933 17.5 9C17.0667 9 16.6417 9.04167 16.225 9.125C15.8083 9.20833 15.4083 9.31667 15.025 9.45C14.725 9.56667 14.4793 9.55833 14.288 9.425C14.0967 9.29167 14.0007 9.075 14 8.775ZM14 14.275C14 14.125 14.0543 13.9707 14.163 13.812C14.2717 13.6533 14.3923 13.5493 14.525 13.5C15.0083 13.3333 15.4917 13.2083 15.975 13.125C16.4583 13.0417 16.9667 13 17.5 13C17.8333 13 18.1627 13.021 18.488 13.063C18.8133 13.105 19.134 13.159 19.45 13.225C19.6 13.2583 19.7293 13.3417 19.838 13.475C19.9467 13.6083 20.0007 13.7583 20 13.925C20 14.2083 19.9083 14.4167 19.725 14.55C19.5417 14.6833 19.3083 14.7167 19.025 14.65C18.7917 14.6 18.546 14.5623 18.288 14.537C18.03 14.5117 17.7673 14.4993 17.5 14.5C17.0667 14.5 16.6417 14.5377 16.225 14.613C15.8083 14.6883 15.4083 14.7923 15.025 14.925C14.725 15.0417 14.479 15.0373 14.287 14.912C14.095 14.7867 13.9993 14.5747 14 14.276V14.275ZM14 11.525C14 11.375 14.0543 11.2207 14.163 11.062C14.2717 10.9033 14.3923 10.7993 14.525 10.75C15.0083 10.5833 15.4917 10.4583 15.975 10.375C16.4583 10.2917 16.9667 10.25 17.5 10.25C17.8333 10.25 18.1627 10.271 18.488 10.313C18.8133 10.355 19.134 10.409 19.45 10.475C19.6 10.5083 19.7293 10.5917 19.838 10.725C19.9467 10.8583 20.0007 11.0083 20 11.175C20 11.4583 19.9083 11.6667 19.725 11.8C19.5417 11.9333 19.3083 11.9667 19.025 11.9C18.7917 11.85 18.546 11.8123 18.288 11.787C18.03 11.7617 17.7673 11.7493 17.5 11.75C17.0667 11.75 16.6417 11.7917 16.225 11.875C15.8083 11.9583 15.4083 12.0667 15.025 12.2C14.725 12.3167 14.4793 12.3083 14.288 12.175C14.0967 12.0417 14.0007 11.825 14 11.525ZM6.5 16C7.28333 16 8.046 16.0877 8.788 16.263C9.53 16.4383 10.2673 16.7007 11 17.05V7.2C10.3167 6.8 9.59167 6.5 8.825 6.3C8.05833 6.1 7.28333 6 6.5 6C5.9 6 5.304 6.05833 4.712 6.175C4.12 6.29167 3.54933 6.46667 3 6.7V16.6C3.58333 16.4 4.16267 16.25 4.738 16.15C5.31333 16.05 5.90067 16 6.5 16ZM13 17.05C13.7333 16.7 14.4707 16.4373 15.212 16.262C15.9533 16.0867 16.716 15.9993 17.5 16C18.1 16 18.6877 16.05 19.263 16.15C19.8383 16.25 20.4173 16.4 21 16.6V6.7C20.45 6.46667 19.879 6.29167 19.287 6.175C18.695 6.05833 18.0993 6 17.5 6C16.7167 6 15.9417 6.1 15.175 6.3C14.4083 6.5 13.6833 6.8 13 7.2V17.05ZM12 19.475C11.7667 19.475 11.5457 19.4457 11.337 19.387C11.1283 19.3283 10.9327 19.2493 10.75 19.15C10.1 18.7667 9.41667 18.4793 8.7 18.288C7.98333 18.0967 7.25 18.0007 6.5 18C5.8 18 5.11233 18.0917 4.437 18.275C3.76167 18.4583 3.116 18.7167 2.5 19.05C2.15 19.2333 1.81267 19.225 1.488 19.025C1.16333 18.825 1.00067 18.5333 1 18.15V6.1C1 5.91667 1.046 5.74167 1.138 5.575C1.23 5.40833 1.36733 5.28333 1.55 5.2C2.31667 4.8 3.11667 4.5 3.95 4.3C4.78333 4.1 5.63333 4 6.5 4C7.46667 4 8.41267 4.125 9.338 4.375C10.2633 4.625 11.1507 5 12 5.5C12.85 5 13.7377 4.625 14.663 4.375C15.5883 4.125 16.534 4 17.5 4C18.3667 4 19.2167 4.1 20.05 4.3C20.8833 4.5 21.6833 4.8 22.45 5.2C22.6333 5.28333 22.771 5.40833 22.863 5.575C22.955 5.74167 23.0007 5.91667 23 6.1V18.15C23 18.5333 22.8377 18.825 22.513 19.025C22.1883 19.225 21.8507 19.2333 21.5 19.05C20.8833 18.7167 20.2377 18.4583 19.563 18.275C18.8883 18.0917 18.2007 18 17.5 18C16.75 18 16.0167 18.096 15.3 18.288C14.5833 18.48 13.9 18.7673 13.25 19.15C13.0667 19.25 12.8707 19.3293 12.662 19.388C12.4533 19.4467 12.2327 19.4757 12 19.475Z" fill="#503B2F"/>
                </svg>
                Términos y condiciones
            </router-link>
            <div class="account__option-item" v-show="isAuthenticated" @click="openAuthModal('change')">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M7 14C6.45 14 5.979 13.804 5.587 13.412C5.195 13.02 4.99933 12.5493 5 12C5 11.45 5.196 10.979 5.588 10.587C5.98 10.195 6.45067 9.99933 7 10C7.55 10 8.021 10.196 8.413 10.588C8.805 10.98 9.00067 11.4507 9 12C9 12.55 8.804 13.021 8.412 13.413C8.02 13.805 7.54933 14.0007 7 14ZM7 18C5.33333 18 3.91667 17.4167 2.75 16.25C1.58333 15.0833 1 13.6667 1 12C1 10.3333 1.58333 8.91667 2.75 7.75C3.91667 6.58333 5.33333 6 7 6C8.11667 6 9.12933 6.275 10.038 6.825C10.9467 7.375 11.6673 8.1 12.2 9H21L24 12L19.5 16.5L17.5 15L15.5 16.5L13.375 15H12.2C11.6667 15.9 10.9457 16.625 10.037 17.175C9.12833 17.725 8.116 18 7 18ZM7 16C7.93333 16 8.75433 15.7167 9.463 15.15C10.1717 14.5833 10.6423 13.8667 10.875 13H14L15.45 14.025L17.5 12.5L19.275 13.875L21.15 12L20.15 11H10.875C10.6417 10.1333 10.1707 9.41667 9.462 8.85C8.75333 8.28333 7.93267 8 7 8C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16Z" fill="#503B2F"/>
                </svg>
                Cambiar contraseña
            </div>
            <div class="account__option-item red" @click="logout()" v-show="isAuthenticated">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M5 21C4.45 21 3.979 20.804 3.587 20.412C3.195 20.02 2.99934 19.5493 3 19V5C3 4.45 3.196 3.979 3.588 3.587C3.98 3.195 4.45067 2.99934 5 3H12V5H5V19H12V21H5ZM16 17L14.625 15.55L17.175 13H9V11H17.175L14.625 8.45L16 7L21 12L16 17Z"/>
                </svg>
                Cerrar sesión
            </div>
        </div>
    </div>
    <EDCMobileNav />
</template>

<script>
import { Auth } from '@/services/auth'
import { AuthModal } from '@/scripts/open-auth'

import EDCHeader from '../components/Header.vue'
import EDCMobileNav from '../components/MobileNav.vue'
import EDCButton from '../components/Button.vue'

export default {
    name: 'edc-account',
    components: {
        EDCHeader,
        EDCMobileNav,
        EDCButton
    },
    data() {
        return {
            isAuthenticated: false,
            user: {
                firstname: localStorage.getItem('auth_firstname'),
                lastname: localStorage.getItem('auth_lastname'),
                email: localStorage.getItem('auth_email')
            }
        }
    },
    methods: {
        logout() {
            Auth.logOut()
        },
        authChange(payload) {
            this.isAuthenticated = payload.logged_in;
        },
        openAuthModal(type) {
            AuthModal.openModal(type)
        },
    },
    mounted() {
        this.isAuthenticated = Auth.isAuthenticated()
        Auth.subscribe(this.authChange)
    }
}
</script>

<style>
.account {
    margin-bottom: 40px;
}

.account__hero {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.account__hero-bk {
    width: 100%;
    height: 240px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.account__hero-bk::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 1;
}

.account__hero-bk-image {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    object-fit: cover;
}

.account__hero-bk-profile {
    width: 150px;
    height: 150px;
    border-radius: 200px;
    overflow: hidden;
    z-index: 9;
    position: relative;
    background-image: url('../assets/avatar.svg');
    background-color: var(--color-light);
    background-repeat: no-repeat;
    background-position: 50%;
    border: 2px solid var(--color-light);
}

.account__hero-bk-profile img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.account__hero-options {
    width: 100%;
    height: 80px;
    z-index: 99;
    border-bottom: 1px solid rgba(0, 0, 0, .15);
}

.account__hero-authenticated {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 12px;
}

.account__hero-person-name {
    font-size: 1.4rem;
    font-weight: bold;
}

.account__hero-person-edit {
    background: none;
    outline: none;
    border: none;
    height: 100%;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.account__hero-not-authenticated {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    position: relative;
}

.account__hero-not-authenticated button {
    position: absolute;
    top: -30%;
    max-width: 240px;
}

.account__hero-login-text {
    font-size: 1.1rem;
    position: relative;
    top: 40px;
}

.account__hero-login-text a {
    color: var(--color-primary);
    font-weight: bold;
    text-decoration: none;
}

.account__options-list {
    padding: 12px 0px;
}

.account__option-item {
    height: 54px;
    padding: 0px 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 1.1rem;
    color: var(--color-dark);
    text-decoration: none;
}

.account__option-item.red { color: #EB5E5E }
.account__option-item.red svg { fill: #EB5E5E }
</style>